import { useSetClientConfig } from '../use-set-teams-client-config';
import { useSetTeamsNavigationConfig } from '../use-set-teams-navigation-config';
import { useSetTeamsProductConfig } from '../use-set-teams-product-config';
export const useSetAppConfig = appConfig => {
  useSetClientConfig({
    cloudId: appConfig.cloudId,
    stargateRoot: appConfig.stargateRoot,
    env: appConfig.env,
    orgId: appConfig.orgId,
    principalUserId: appConfig.principalUserId
  });
  useSetTeamsProductConfig({
    appName: appConfig.appName,
    productName: appConfig.productName,
    isJiraAvailable: appConfig.isJiraAvailable,
    subProduct: appConfig.subProduct,
    locale: appConfig.locale,
    productFeatureFlags: appConfig.productFeatureFlags
  });
  useSetTeamsNavigationConfig({
    contextSpaPaths: appConfig.contextSpaPaths,
    contextEntryPoint: appConfig.contextEntryPoint
  });
};